const EMPLOYER = 'employer'

export enum EmployerAdvisorsRoutePathsEnum {
  ADVISORS = `/${EMPLOYER}/planners`,
}
